<!-- TODO: check usage -->
<template>
  <div :class="$style.modal">
    <UserConcernAndDiagnosis :class="$style.modal__result" :karte="karte" />
    <div :class="$style.modal__action">
      <FlatButton @click="$emit('close')" variant="plain" size="medium">
        戻る
      </FlatButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import UserConcernAndDiagnosis from '@/components/organisms/UserConcernAndDiagnosis/UserConcernAndDiagnosis.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { type UserConcernAndDiagnosisModalKarteFragment } from './UserConcernAndDiagnosisModal.generated'

defineProps<{
  karte: UserConcernAndDiagnosisModalKarteFragment
}>()
</script>

<style lang="scss" module>
.modal {
  max-width: 840px;
  padding: 40px;
  background-color: $color-surface-secondary;

  &__action {
    display: flex;
    justify-content: flex-end;

    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}
</style>
